const getExtensionI18nextNamespace = (slug) => `extension-${slug}`;

export default getExtensionI18nextNamespace;
